// extracted by mini-css-extract-plugin
export var button = "social-panel-module--button--6918a";
export var postSocial = "social-panel-module--post-social--83b0e";
export var postSocialText = "social-panel-module--post-social-text--06186";